import { createLocaleProvider as a } from "@ado/location-library";
import { createTranslation as s } from "@ado/translation-library";
import { importI18nModules as d } from "./import-i18n-modules.js";
class p {
  additionalModules;
  constructor(e) {
    this.additionalModules = e;
  }
  install(e) {
    const t = d(), o = a().provideCurrent().getValue();
    s(
      o,
      this.mergeModules(t, this.additionalModules)
    ).install(e);
  }
  mergeModules(e, t) {
    const o = { ...e };
    return t !== void 0 && Object.keys(t).forEach((r) => {
      let i = r, l = 1;
      for (; o[i] !== void 0; )
        i = `${r}${l++}`;
      o[i] = t[r];
    }), o;
  }
}
export {
  p as AcsStandardLibraryI18nPlugin
};
//# sourceMappingURL=acs-standard-library-i18n-plugin.js.map
